import { Button, Col, Container, Row } from 'react-bootstrap'
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'
import "./Groups.css"
import TableComponent from '../../../Table/Table';

export default function Group() {
    const [searchParams] = useSearchParams();

    const AffiliateID = searchParams.get('id');

    const [loading, setLoading] = useState(true);
    const [commissiongroups, setCommissionGroups] = useState([]);
    const [affiliategroups, setAffiliateGroups] = useState([]);
    const [commission, setCommission] = useState([]);
    const [affiliategroup, setAffiliategroup] = useState([]);
    const [subaffiliategroup, setSubAffiliategroup] = useState([]);
    const [selectedgroup, setSelectedGroup] = useState("");
    const [selectedaffgroup, setSelectedAffGroup] = useState("");
    const [selectedsubaffgroup, setSelectedSubAffGroup] = useState("");

    const nav = useNavigate();
    const columns = React.useMemo(
        () => [
            {
                Header: 'Group ID',
                accessor: 'Id',
            },
            {
                Header: 'Currency',
                accessor: 'Currency',
            },
            {
                Header: 'Name',
                accessor: 'Name',
            },
            {
                Header: 'Status',
                accessor: 'Status',
            }
        ],
        []
    );
    const columns1 = React.useMemo(
        () => [
            {
                Header: 'Group ID',
                accessor: 'Id',
            },
            {
                Header: 'Currency',
                accessor: 'Currency',
            },
            {
                Header: 'Name',
                accessor: 'Name',
            },
            {
                Header: 'Status',
                accessor: 'Status',
            }
        ],
        []
    );

    const GetGroups = async () => {
        try {
            setLoading(true);

            const response = await axios.get(window.__CFG.API + "affiliates/GetAffiliateGroups/" + AffiliateID, {
                headers : {
                    "Authorization" : "Bearer "+localStorage.getItem("raff-token")
                }
            })

            setLoading(false);

            if(response.data.Error == null) {
                setCommission(response.data.Result.Commission);
                setAffiliategroup(response.data.Result.AffiliateGroup);
                setSubAffiliategroup(response.data.Result.SubAffiliateGroup);
            }
        } catch(e) {
            console.log(e);
        }
    }

    useEffect(() => {
        GetGroups();
    }, []);

    const GetAllGroups = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        const affresponse = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            setCommissionGroups(response.data.Result.filter(d => {
                return d.value != ""
            }));
        }
        if(affresponse.data.Error == null) {
            setAffiliateGroups(affresponse.data.Result.filter(d => {
                return d.value != ""
            }));
        }
    }

    useEffect(() => {
        GetAllGroups();
    }, []);

    const ChangeCommissionGroup = async () => {
        setLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/ChangeAffiliateCommissionGroup/"+AffiliateID, {
            group : selectedgroup
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            GetGroups();
        } else {
            setLoading(false);
        }
    }
    const ChangeAffiliateGroup = async () => {
        setLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/ChangeAffiliateGroup/"+AffiliateID, {
            group : selectedaffgroup
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            GetGroups();
        } else {
            setLoading(false);
        }
    }
    const ChangeSubAffiliateGroup = async () => {
        setLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/ChangeSubAffiliateGroup/"+AffiliateID, {
            group : selectedsubaffgroup
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            GetGroups();
        } else {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="aff-grp-wrp">
                <div className='aff-grp-section-wp'>
                    <div className='aff-grp-section'>
                        <div className='aff-grp-section-title'>
                            Edit commission group
                        </div>
                        <div className='aff-gr-section-row'>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Currency
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select style={{ width: "100%", padding: 5 }} >
                                        <option>USD</option>
                                    </select>
                                </div>
                            </div>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Commission group
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select onChange={e => setSelectedGroup(e.target.value)} style={{ width: "100%", padding: 5 }} >
                                        <option value="">Select Group</option>
                                        {
                                            commissiongroups.map(group => {
                                                return (
                                                    <option value={group.value}>{group.label}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='aff-grp-section-btn'>
                            <Button disabled={loading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                onClick={ChangeCommissionGroup}
                            >
                                Edit
                            </Button>
                        </div>
                        <div className='aff-grp-section-table-title'>
                            Commission groups
                        </div>
                        <div className='aff-grp-section-table'>
                            <div className="aff-dash-summary-table">
                                <TableComponent loading={loading} columns={columns} data={commission} />
                            </div>
                        </div>
                    </div>
                    <div className='aff-grp-section'>
                        <div className='aff-grp-section-title'>
                            Edit affiliate group
                        </div>
                        <div className='aff-gr-section-row'>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Currency
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select style={{ width: "100%", padding: 5 }} >
                                        <option>USD</option>
                                    </select>
                                </div>
                            </div>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Affiliate group
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select onChange={e => setSelectedAffGroup(e.target.value)} style={{ width: "100%", padding: 5 }} >
                                        <option value="">Select Group</option>
                                        {
                                            affiliategroups.map(group => {
                                                return (
                                                    <option value={group.value}>{group.label}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='aff-grp-section-btn'>
                            <Button onClick={ChangeAffiliateGroup} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                            >
                                Edit
                            </Button>
                        </div>
                        <div className='aff-grp-section-table-title'>
                            Affiliate groups
                        </div>
                        <div className='aff-grp-section-table'>
                            <div className="aff-dash-summary-table">
                                <TableComponent loading={loading} columns={columns1} data={affiliategroup} />
                            </div>
                        </div>
                    </div>
                    <div className='aff-grp-section'>
                        <div className='aff-grp-section-title'>
                            Edit sub affiliate group
                        </div>
                        <div className='aff-gr-section-row'>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Currency
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select style={{ width: "100%", padding: 5 }} >
                                        <option>USD</option>
                                    </select>
                                </div>
                            </div>
                            <div className='aff-gr-section-col'>
                                <div className='aff-gr-section-lbl'>
                                    Affiliate group
                                </div>
                                <div className='aff-gr-section-in'>
                                    <select onChange={e => setSelectedSubAffGroup(e.target.value)} style={{ width: "100%", padding: 5 }} >
                                        <option value="">Select Group</option>
                                        {
                                            affiliategroups.map(group => {
                                                return (
                                                    <option value={group.value}>{group.label}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='aff-grp-section-btn'>
                            <Button onClick={ChangeSubAffiliateGroup} disabled={loading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                            >
                                Edit
                            </Button>
                        </div>
                        <div className='aff-grp-section-table-title'>
                           Sub Affiliate groups
                        </div>
                        <div className='aff-grp-section-table'>
                            <div className="aff-dash-summary-table">
                                <TableComponent loading={loading} columns={columns1} data={subaffiliategroup} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}